import React, {Component} from 'react';
import RedirectOnlyHome from "../common/RedirectOnlyHome";

class SuccessPaymentPage extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}
	render() {
		return (<>
			<RedirectOnlyHome />
			<div className={'col text-center'} style={{padding: "20px 30px", marginBottom: "25px"}}>
				<h3 style={{color:"#d63545"}}>Thank you for your payment to Go With The Gecko. <br/>We have received your payment for our services.</h3>
				<div>
					<br/><br/>
					If you have any further questions for the team, please contact support at <a href="tel:1300826883">1300 826 883</a>.
				</div>
				<div>
					<br/><br/>
					<strong>Thank you very much, have a nice day!</strong><br/>
					<em>Go With The Gecko Team</em>
				</div>
			</div>
		</>);
	}
}

export default SuccessPaymentPage;